import Result from 'ant-design-pro/lib/Result';
import { Button, DatePicker, Form, InputNumber, message, Row, Steps } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Panel } from 'src/components/Panel';
import { client } from 'src/services/api';
import { MarketingActivityRuleKey, MarketingActivityRuleType } from 'src/types/marketingActivity';

import { createMarketingActivityRulesMutation, LimitConfigValue, LimitCongValue, Rule } from './AdvancedDesposit';
import { LimitSku, UserLimitConfigForm } from './UserLimitConfig';

const { Step } = Steps;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};
interface Props {
  form: WrappedFormUtils;
  activityId: number;
}
interface State {
  dueAt: Date;
  current: number;
  limitSkuList: LimitSku[];
  price: number;
  remark: string;
}

export class LimitedTimeSale extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      dueAt: new Date(),
      current: 0,
      price: 0,
      remark: '',
      limitSkuList: [
        {
          id: '0',
          isLimitSku: 'named',
          skuId: '',
          isLimitOwnedSku: 'named',
          ownedSkuId: '',
        },
      ],
    };
  }

  onDueAtChange = (date: moment.Moment) => {
    this.setState({
      dueAt: moment(date).endOf('day').utc().toDate(),
    });
  };

  onMarketingPriceChange = (value: number) => {
    this.setState({ price: value });
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };

  userLimitRuleList = () => {
    const { activityId } = this.props;
    const { limitSkuList } = this.state;
    const userLimitConfigValues: Rule[] = [];
    limitSkuList.forEach(item => {
      const limitConfig: LimitCongValue = {};
      if (item.isLimitOwnedSku === 'named') {
        limitConfig.ownedSkuId = Number(item.ownedSkuId);
        userLimitConfigValues.push({
          activityId,
          remark: '用户限制配置',
          ruleKey: MarketingActivityRuleKey.MA_RULE_USERS_LIMIT_CONFIG,
          ruleName: '限时优惠活动用户sku限制',
          ruleType: MarketingActivityRuleType.CONSTRAINT,
          ruleValue: { ownedSkuId: Number(item.ownedSkuId) },
        });
      }

      if (item.isLimitSku === 'named') {
        limitConfig.skuId = Number(item.skuId);
      }
      userLimitConfigValues.push({
        activityId,
        remark: '拥有与购买SKU映射',
        ruleKey: MarketingActivityRuleKey.USER_SKU_MAPPING,
        ruleName: '拥有与购买SKU映射',
        ruleType: MarketingActivityRuleType.DETAIL,
        ruleValue: limitConfig,
      });
    });
    return userLimitConfigValues;
  };

  activityContentConfig = () => {
    const { activityId } = this.props;
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const { dueAt, price, remark } = this.state;
      const ruleValue: LimitConfigValue = {
        dueAt,
        price,
      };

      const rule: Rule = {
        ruleValue,
        activityId,
        remark,
        ruleKey: MarketingActivityRuleKey.MA_RELATION_LIMITED_TIME_SALE,
        ruleName: '限时活动配置',
        ruleType: MarketingActivityRuleType.DETAIL,
      };
      const configList: Rule[] = [...this.userLimitRuleList(), rule];
      await client
        .mutate({
          mutation: createMarketingActivityRulesMutation,
          variables: { activityId: Number(activityId), rules: configList },
        })
        .then(res => {
          if (res.data) {
            message.success('设置成功！');
            const current = this.state.current + 1;
            this.setState({ current });
          }
        })
        .catch(error => {
          const [err] = error.graphQLErrors;
          message.error(err.message);
        });
    });
  };

  next = (list: LimitSku[]) => {
    const current = this.state.current + 1;
    this.setState({ current, limitSkuList: list });
  };

  configStart = () => {
    this.setState({ current: 0 });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { activityId } = this.props;
    const { limitSkuList, current, dueAt, price } = this.state;
    const steps = [
      {
        title: '用户限制配置',
        content: (
          <UserLimitConfigForm
            limitSkuList={limitSkuList}
            activityId={Number(activityId)}
            next={list => this.next(list)}
          />
        ),
      },
      {
        title: '活动配置',
        content: (
          <Form style={{ marginTop: 30 }}>
            <Form.Item {...formItemLayout} label="限时优惠截止时间">
              {getFieldDecorator('dueAt', {
                initialValue: moment(dueAt),
                rules: [
                  {
                    required: true,
                    message: '请填写结束时间',
                  },
                ],
              })(<DatePicker onChange={this.onDueAtChange} />)}
            </Form.Item>
            <Form.Item label="活动价格" {...formItemLayout}>
              {getFieldDecorator('price', {
                initialValue: price,
                rules: [
                  {
                    required: true,
                    message: '活动价格',
                  },
                ],
              })(<InputNumber placeholder="活动价格" min={0} onChange={this.onMarketingPriceChange} />)}
            </Form.Item>
            <Row type="flex" justify="end">
              <Button type="primary" style={{ marginRight: 5 }} onClick={this.prev}>
                上一步
              </Button>
              <Button type="primary" onClick={this.activityContentConfig}>
                完成配置
              </Button>
            </Row>
          </Form>
        ),
      },
      {
        title: '配置完成',
        content: <Result style={{ marginTop: 30 }} title="配置成功！" type="success" />,
      },
    ];
    return (
      <>
        <Panel style={{ padding: 20 }}>
          <Steps current={current}>
            {steps.map(item => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content">{steps[current].content}</div>
        </Panel>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/LimitedTimeSale.tsx